import { getConfigTenant, isCorpTenant } from "@capone/common";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import { ButtonWrap, Icon, IconName, useDeviceTypes } from "halifax";
import React from "react";
import {
  CorpMarketplacePackagesNameVariantType,
  HOTELS_FLIGHTS,
  TRIP_BUILDER,
} from "@capone/experiments";
import { PackagesInfoModal } from "..";
import {
  CORPORATE_INFO_MODAL_CTA_TEXT,
  CORPORATE_INFO_MODAL_CTA_TEXT_HOTELS_FLIGHTS,
  CORPORATE_INFO_MODAL_CTA_TEXT_TRIP_BUILDER,
  INFO_MODAL_CTA_TEXT,
} from "../../textConstants";
import "./styles.scss";

export interface HowPackagesWorkProps {
  corpPackagesNameVariant: CorpMarketplacePackagesNameVariantType;
  className?: string;
}

export const HowPackagesWork = ({
  corpPackagesNameVariant,
  className,
}: HowPackagesWorkProps) => {
  const [packagesInfoModalOpen, setPackagesInfoModalOpen] =
    React.useState(false);

  const { matchesMobile } = useDeviceTypes();
  const isCorporate = isCorpTenant(getConfigTenant());

  const getInfoModalCtaText = () => {
    if (!isCorporate) {
      return INFO_MODAL_CTA_TEXT;
    }

    switch (corpPackagesNameVariant) {
      case TRIP_BUILDER:
        return CORPORATE_INFO_MODAL_CTA_TEXT_TRIP_BUILDER;
      case HOTELS_FLIGHTS:
        return CORPORATE_INFO_MODAL_CTA_TEXT_HOTELS_FLIGHTS;
      default:
        return CORPORATE_INFO_MODAL_CTA_TEXT;
    }
  };

  return (
    <Box
      className={clsx("how-packages-work-container", className, {
        mobile: matchesMobile && isCorporate,
      })}
    >
      <ButtonWrap
        className="packages-info-cta"
        onClick={() => setPackagesInfoModalOpen(true)}
      >
        <Box className={clsx("new-tag", { corporate: isCorporate })}>New</Box>
        <Typography className="packages-info-cta-text">
          {getInfoModalCtaText()}
        </Typography>
        <Icon name={IconName.InfoCircle} />
      </ButtonWrap>

      <PackagesInfoModal
        open={packagesInfoModalOpen}
        setOpen={setPackagesInfoModalOpen}
        corpPackagesNameVariant={corpPackagesNameVariant}
      />
    </Box>
  );
};
